import { Routes, Route, useParams, Navigate, Outlet } from "react-router-dom";
import { useEffect } from "react";
import { Suspense, lazy } from 'react';
import { useTranslation } from "react-i18next";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// Lazy loading components for better performance
const Home = lazy(() => import('./pages/home'));
const Register = lazy(() => import('./pages/register'));
const Contact = lazy(() => import('./pages/contact'));
const ContactLogs = lazy(() => import('./pages/logsContact/contactLogs'));
const About_Us = lazy(() => import('./pages/about_us.js'));
const Faqs = lazy(() => import('./pages/faqs.js'));
const NotFound = lazy(() => import('./pages/NotFound.js'));
const SearchPage = lazy(() => import('./pages/searchPage.js'));

//Reset pass
const ForgotPasswordPage = lazy(() => import('./pages/resetPass/ForgotPasswordPage.js'));
const ResetPasswordPage = lazy(() => import('./pages/resetPass/ResetPasswordPage.js'));
//User
const Account = lazy(() => import('./pages/user/account'));
const EditProfile = lazy(() => import('./pages/user/editProfile'));
const MyProductList = lazy(() => import('./pages/user/myProductList.js'));
const UserSubscriptions = lazy(() => import('./pages/user/userSubscriptions.js'));
//Admin
const AdminUserList = lazy(() => import('./pages/admin/user/adminUserList.js'));
const AdminUserEdit = lazy(() => import('./pages/admin/user/adminUserEdit.js'));

const AdminTopProducts = lazy(() => import('./pages/admin/top/adminTopProducts.js'));
const AdminTopCompanies = lazy(() => import('./pages/admin/top/adminTopCompanies.js'));
const AdminTopCompaniesRegional = lazy(() => import('./pages/admin/top/adminTopCompaniesRegional.js'));
const AdminTopRegionalServices = lazy(() => import('./pages/admin/top/adminTopRegionalServices.js'));
const AdminTopGlobalServices = lazy(() => import('./pages/admin/top/AdminTopGlobalServices.js'));

const AdminGlobalCompany = lazy(() => import('./pages/admin/companiesServicesDelete/adminGlobalCompany.js'));
const AdminLocalCompany = lazy(() => import('./pages/admin/companiesServicesDelete/adminLocalCompany.js'));
const AdminLocalServices = lazy(() => import('./pages/admin/companiesServicesDelete/adminLocalServices.js'));
const AdminGlobalServices = lazy(() => import('./pages/admin/companiesServicesDelete/adminGlobalServices.js'));

const AdminCompanyAside = lazy(() => import('./pages/admin/asides/adminCompanyAside.js'));
const AsideConfigList = lazy(() => import('./pages/admin/asides/asideConfigList.js'));
const EditAsidePage = lazy(() => import('./pages/admin/asides/editAsidePage.js'));
const AsideGroupEditor = lazy(() => import('./pages/admin/asides/asideGruopEditor.js'));
const AsideLocationManager = lazy(() => import('./pages/admin/asides/asideLocationManager.js'));
const VideosList = lazy(() => import('./pages/admin/videoList.js'));
const VideosCreate = lazy(() => import('./pages/admin/videoCreate.js'));
const VideosEdit = lazy(() => import('./pages/admin/videoEdit.js'));
const SliderImageUploader = lazy(() => import('./pages/admin/sliders/SliderImageUploader.js'));
const SliderList = lazy(() => import('./pages/admin/sliders/SliderList.js'));
const EditSliderImage = lazy(() => import('./pages/admin/sliders/EditSliderImage.js'));
const SectorsAdminPage = lazy(() => import('./pages/admin/sectorsAdminPage.js'));
const SectorCreateForm = lazy(() => import('./pages/admin/sectorsCreateForm.js'));
const SectorEditForm = lazy(() => import('./pages/admin/sectorEditForm.js'));
const CategoriesAdminPage = lazy(() => import('./pages/admin/categoriasAdminPage.js'));
const CategoryCreatePage = lazy(() => import('./pages/admin/categoryCreatePage .js'));
const CategoryEditPage = lazy(() => import('./pages/admin/categoryEditPage  .js'));
const SubcategoriesAdminPage = lazy(() => import('./pages/admin/subcategoriesAdminPage.js'));
const SubcategoryCreateForm = lazy(() => import('./pages/admin/subcategoryCreateForm.js'));
const SubcategoryEditForm = lazy(() => import('./pages/admin/subcategoryEditForm.js'));
const DivisionsAdminPage = lazy(() => import('./pages/admin/divisionsAdminPage.js'));
const DivisionCreateForm = lazy(() => import('./pages/admin/divisionCreateForm.js'));
const DivisionEditForm = lazy(() => import('./pages/admin/divisionEditForm.js'));
const AdminSitemap = lazy(() => import('./pages/admin/sitemapAdmin.js'));
//messages
const InboxPage = lazy(() => import('./pages/user/inboxPage.js'));
const SentPage = lazy(() => import('./pages/user/sentPage.js'));
// Sectors related pages
const Primary = lazy(() => import('./pages/sectors/primary'));
const Secondary = lazy(() => import('./pages/sectors/secondary'));
const Tertiary = lazy(() => import('./pages/sectors/tertiary'));
const Quaternary = lazy(() => import('./pages/sectors/quaternary'));
const Quinary = lazy(() => import('./pages/sectors/quinary'));

//services regional
const CreateService = lazy(() => import('./pages/servicesRegionalSection/CreateService.js'));
const EditService = lazy(() => import('./pages/servicesRegionalSection/EditService.js'));

//services global
const CreateServiceGlobal = lazy(() => import('./pages/servicesGlobalSection/CreateService.js'));
const EditServiceGlobal = lazy(() => import('./pages/servicesGlobalSection/EditService.js'));

//empresas regionales

const CreateEmpresaRegional = lazy(() => import('./pages/productRegional/CreateEmpresa.js'));
const EditEmpresaRegional = lazy(() => import('./pages/productRegional/EditEmpresa.js'));


// Business related pages
const Business = lazy(() => import('./pages/business/business'));
const Business_Videos = lazy(() => import('./pages/business/business_videos'));
const Featured_Business = lazy(() => import('./pages/business/FeaturedBusiness/featured_business.js'));
const Featured_Regional_Business = lazy(() => import('./pages/business/FeaturedBusiness/featured_regional_business.js'));
const Featured_Regional_Services = lazy(() => import('./pages/business/FeaturedBusiness/featured_regional_services.js'));
const Featured_Global_Services = lazy(() => import('./pages/business/FeaturedBusiness/featured_global_services.js'));
const Products = lazy(() => import('./pages/business/products'));
const TopProductsPage = lazy(() => import('./pages/business/topProductsPage.js'));
const Services = lazy(() => import('./pages/business/services'));

const CompanyProfile = lazy(() => import('./pages/perfilesCompanies/CompanyProfile.js'));
const CompanyRegionalProfile = lazy(() => import('./pages/perfilesCompanies/CompanyRegionalProfile.js'));
const ServiceRegionalProfile = lazy(() => import('./pages/perfilesCompanies/ServiceRegionalProfile.js'));
const ServiceGlobalProfile = lazy(() => import('./pages/perfilesCompanies//ServiceGlobalProfile.js'));

const CompanyContent = lazy(() => import('./pages/business/companyContent/companyContent.js'));
const CompanyContentEditor = lazy(() => import('./pages/business/companyContent/CompanyContentEditor.js'));
const CreateCompanyContent = lazy(() => import('./pages/business/companyContent/CreateCompanyContent.js'));
const CreateCompanyPage = lazy(() => import('./pages/empresasGlobales/createCompanyPage.js'));
const EditCompanyPage = lazy(() => import('./pages/empresasGlobales/editCompanyPage.js'));
const CompaniesPage = lazy(() => import('./pages/business/CompaniesPage.js'));
const EmpresasRegionales = lazy(() => import('./pages/business/empresasRegionales.js'));
const RegionalServices = lazy(() => import('./pages/business/regionalServices.js'));
const GlobalServices = lazy(() => import('./pages/business/globalServices.js'));
// Solutions related pages
const Help = lazy(() => import('./pages/solutions/help'));
const Positioning = lazy(() => import('./pages/solutions/positioning'));
const Marketing = lazy(() => import('./pages/solutions/marketing'));
const Landing_Pages = lazy(() => import('./pages/solutions/landing_pages'));
const Consultancy = lazy(() => import('./pages/solutions/consultancy'));
// Memberships
const Memberships = lazy(() => import('./pages/memberships/memberships'));
// Fairs
const Calendar = lazy(() => import('./pages/fairs/calendar'));
const Campaigns = lazy(() => import('./pages/fairs/campaigns'));
const Virtual_Fairs = lazy(() => import('./pages/fairs/virtual_fairs'));
const EventsList = lazy(() => import('./pages/fairs/eventLinst.js'));
const EventsCreate = lazy(() => import('./pages/fairs/eventsCreate.js'));
const EventsEdit = lazy(() => import('./pages/fairs/eventsEdit.js'));
const Auctions = lazy(() => import('./pages/fairs/auctions'));
//Products
const ProductsPage = lazy(() => import('./pages/products/productsPage'));
const ProductDetailPage = lazy(() => import('./pages/products/productDetailPage.js'));
const CreateProductCard = lazy(() => import('./pages/products/createProductPage.js'));
const ProductEditPage = lazy(() => import('./pages/products/productEditPage.js'));
//Buying
const MyBuyings = lazy(() => import('./pages/buying/myBuyings.js'));
const CreateBuying = lazy(() => import('./pages/buying/createBuying.js'));
const EditBuying = lazy(() => import('./pages/buying/edithBuying.js'));
const AllBuyingsPage = lazy(() => import('./pages/buying/allBuyingsPage.js'));
const BuyingDetail = lazy(() => import('./pages/buying/buyingDetail.js'));
//Affiliate
const AffiliatePage = lazy(() => import('./pages/affiliate/AffiliatePage.js'));
const CommissionPlus = lazy(() => import('./pages/affiliate/commissionPlus.js'));
const AffiliateBannerList = lazy(() => import('./pages/affiliate/AffiliateBannerList.js'));
const AffiliateBannerForm = lazy(() => import('./pages/affiliate/AffiliateBannerForm.js'));
const EditAffiliateBannerPage = lazy(() => import('./pages/affiliate/EditAffiliateBannerPage.js'));
//Resources
const Success_Stories = lazy(() => import('./pages/resources/success_stories'));
const Manuals = lazy(() => import('./pages/resources/manuals'));
// App components
const Header = lazy(() => import('./components/header'));
const Footer = lazy(() => import('./components/footer'));

function Layout() {
  const { lng } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    // Solo cambiar si es diferente
    // istanbul ignore next
    if (lng && i18n.language !== lng) {
      i18n.changeLanguage(lng);
    }
  }, [lng, i18n]);

  return (
    <>
      <Header />
      <Suspense fallback={<div className="text-center py-5">Loading...</div>}>
        <Outlet />
      </Suspense>
      <Footer />
    </>
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    }
  }
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path="/" element={<Navigate to="/en" replace />} />
        <Route path="/:lng" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about-us" element={<About_Us />} />
          <Route path="register" element={<Register />} />
          <Route path="contact" element={<Contact />} />
          <Route path="contact-logs" element={<ContactLogs />} />
          <Route path="faqs" element={<Faqs />} />
          <Route path="search-page" element={<SearchPage />} />

          <Route path="dashboard/services/create" element={<CreateService />} />
          <Route path="dashboard/services/edit/:id" element={<EditService />} />

          <Route path="dashboard/services-global/create" element={<CreateServiceGlobal />} />
          <Route path="dashboard/services-global/edit/:id" element={<EditServiceGlobal />} />

          <Route path="dashboard/business-regional/create" element={<CreateEmpresaRegional />} />
          <Route path="dashboard/business-regional/edit/:id" element={<EditEmpresaRegional />} />

          <Route path="forgot-password" element={<ForgotPasswordPage />} />
          <Route path="reset-password" element={<ResetPasswordPage />} />

          <Route path="account" element={<Account />} />
          <Route path="edit-profile" element={<EditProfile />} />
          <Route path="inbox" element={<InboxPage />} />
          <Route path="sent" element={<SentPage />} />

          <Route path="admin/users" element={<AdminUserList />} />
          <Route path="admin/users/:id" element={<AdminUserEdit />} />
          <Route path="admin/top-products" element={<AdminTopProducts />} />

          <Route path="admin/top-companies" element={<AdminTopCompanies />} />
          <Route path="admin/top-companies-regional" element={<AdminTopCompaniesRegional />} />
          <Route path="admin/top-services-regional" element={<AdminTopRegionalServices />} />
          <Route path="admin/top-services-global" element={<AdminTopGlobalServices />} />

          <Route path="admin/global-company" element={<AdminGlobalCompany />} />
          <Route path="admin/local-company" element={<AdminLocalCompany />} />
          <Route path="admin/local-services" element={<AdminLocalServices />} />
          <Route path="admin/global-services" element={<AdminGlobalServices />} />

          <Route path="admin/aside" element={<AdminCompanyAside />} />
          <Route path="admin/aside-list" element={<AsideConfigList />} />
          <Route path="admin/aside/edit/:configKey" element={<EditAsidePage />} />
          <Route path="admin/aside-groups" element={<AsideGroupEditor />} />
          <Route path="admin/aside-locations" element={<AsideLocationManager />} />
          <Route path="admin/videos-list" element={<VideosList />} />
          <Route path="admin/videos-create" element={<VideosCreate />} />
          <Route path="admin/videos-edit/:id" element={<VideosEdit />} />
          <Route path="admin/slider-image-upload" element={<SliderImageUploader />} />
          <Route path="admin/slider-list" element={<SliderList />} />
          <Route path="admin/edit-slider/:id" element={<EditSliderImage />} />
          <Route path="admin/sectors" element={<SectorsAdminPage />} />
          <Route path="admin/sectors/create" element={<SectorCreateForm />} />
          <Route path="admin/sectors/edit/:id" element={<SectorEditForm />} />
          <Route path="admin/categories" element={<CategoriesAdminPage />} />
          <Route path="admin/categories/create" element={<CategoryCreatePage />} />
          <Route path="admin/categories/edit/:id" element={<CategoryEditPage />} />
          <Route path="admin/subcategories" element={<SubcategoriesAdminPage />} />
          <Route path="admin/subcategories/create" element={<SubcategoryCreateForm />} />
          <Route path="admin/subcategories/edit/:id" element={<SubcategoryEditForm />} />
          <Route path="admin/divisions" element={<DivisionsAdminPage />} />
          <Route path="admin/divisions/create" element={<DivisionCreateForm />} />
          <Route path="admin/divisions/edit/:id" element={<DivisionEditForm />} />
          <Route path="admin/sitemap-admin" element={<AdminSitemap />} />
          <Route path="admin/affiliate-banners/list" element={<AffiliateBannerList />} />
          <Route path="admin/affiliate-banners/create" element={<AffiliateBannerForm />} />
          <Route path="admin/affiliate-banners/edit/:id" element={<EditAffiliateBannerPage />} />

          <Route path="commission-plus" element={<CommissionPlus />} />
          <Route path="affiliate" element={<AffiliatePage />} />

          <Route path="subscriptions" element={<UserSubscriptions />} />

          <Route path="my-products" element={<MyProductList />} />
          <Route path="products/new" element={<CreateProductCard />} />
          <Route path="products-page" element={<ProductsPage />} />
          <Route path="products/:id" element={<ProductDetailPage />} />
          <Route path="products/edit/:id" element={<ProductEditPage />} />

          <Route path="primary" element={<Primary />} />
          <Route path="secondary" element={<Secondary />} />
          <Route path="tertiary" element={<Tertiary />} />
          <Route path="quaternary" element={<Quaternary />} />
          <Route path="quinary" element={<Quinary />} />

          <Route path="business" element={<Business />} />
          <Route path="business-videos" element={<Business_Videos />} />

          <Route path="featured-business" element={<Featured_Business />} />
          <Route path="featured-regional-business" element={<Featured_Regional_Business />} />
          <Route path="featured-regional-services" element={<Featured_Regional_Services />} />
          <Route path="featured-global-services" element={<Featured_Global_Services />} />

          <Route path="products" element={<Products />} />
          <Route path="top-products" element={<TopProductsPage />} />
          <Route path="services" element={<Services />} />
          <Route path="regional-companies" element={<EmpresasRegionales />} />
          <Route path="regional-services" element={<RegionalServices />} />
          <Route path="global-services" element={<GlobalServices />} />

          <Route path="company/:company_id" element={<CompanyProfile />} />
          <Route path="company-regional/:company_id" element={<CompanyRegionalProfile />} />
          <Route path="service-regional/:company_id" element={<ServiceRegionalProfile />} />
          <Route path="service-global/:company_id" element={<ServiceGlobalProfile />} />

          <Route path="company-content/:slug" element={<CompanyContent />} />
          <Route path="memberships" element={<Memberships />} />
          <Route path="content-editor/:entityType/:entityId" element={<CompanyContentEditor />} />
          <Route path="content-create/:entityType/:entityId" element={<CreateCompanyContent />}
          />
          <Route path="create-company-content/:companyId" element={<CreateCompanyContent />} />
          <Route path="create-company-page" element={<CreateCompanyPage />} />
          <Route path="edit-company/:id" element={<EditCompanyPage />} />
          <Route path="companies-page" element={<CompaniesPage />} />

          <Route path="help" element={<Help />} />
          <Route path="positioning" element={<Positioning />} />
          <Route path="marketing" element={<Marketing />} />
          <Route path="landing_pages" element={<Landing_Pages />} />
          <Route path="consultancy" element={<Consultancy />} />

          <Route path="calendar" element={<Calendar />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="virtual-fairs" element={<Virtual_Fairs />} />
          <Route path="admin/events-list" element={<EventsList />} />
          <Route path="admin/events-create" element={<EventsCreate />} />
          <Route path="admin/events-edit/:id" element={<EventsEdit />} />
          <Route path="auctions" element={<Auctions />} />

          <Route path="my-buyings" element={<MyBuyings />} />
          <Route path="buyings" element={<AllBuyingsPage />} />
          <Route path="create-buying" element={<CreateBuying />} />
          <Route path="edit-buying/:id" element={<EditBuying />} />
          <Route path="buying/:id" element={<BuyingDetail />} />



          <Route path="success-stories" element={<Success_Stories />} />
          <Route path="manuals" element={<Manuals />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </QueryClientProvider>
  );

}

export default App;
